import { createSelector } from 'reselect';

const selectDomain = (state) => state.decks;

export const selectDecks = createSelector(
  [selectDomain], (state) => state.get('decks').sortBy(deck => deck.get('name')),
);

/** The decks that can be chosen for a game: every card in them can be played (the server's `playable`). */
export const selectPlayableDecks = createSelector(
  [selectDecks], (decks) => decks.filter(deck => deck.get('playable') !== false),
);

/** Every deck in the order they came out, then by name; one with no known date goes last. */
export const selectDecksByRelease = createSelector(
  [selectDecks], (decks) => decks.sortBy(deck => `${deck.get('released_on') || '9999'} ${deck.get('name')}`),
);

export const selectDecksLoaded = createSelector(
  [selectDomain], (state) => state.get('decksLoaded')
);
